import React from 'react';

export default function TrendIcon(props: any) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <path
        d="m20,0c2.20914,0 4,1.79086 4,4l0,16c0,2.20914 -1.79086,4 -4,4l-16,0c-2.20914,0 -4,-1.79086 -4,-4l0,-16c0,-2.20914 1.79086,-4 4,-4l16,0zm2,6l-6,0l2.29,2.29l-4.88,4.88l-4,-4l-7.41,7.42l1.41,1.41l6,-6l4,4l6.3,-6.29l2.29,2.29l0,-6z"
        id="svg_2"
      />
    </svg>
  );
}
